export const TOGGLE_MOBILE_OPEN = 'TOGGLE_MOBILE_OPEN'